<div class="d-flex align-items-center justify-content-center" role="status">
  <img [attr.width]="width" height="auto" src="assets/images/misc/phLoading.gif" />
  <span class="sr-only" i18n>Loading...</span>
</div>
